// ABOUTME: SPEC-76 — the small-screen behaviour of the read-first panel's text column: a bottom fade while more is hidden
// ABOUTME: below, so a line cut at the card edge reads as "scroll for more" and not as clipping.

import { useLayoutEffect, useRef, useState } from 'react';

// Why this exists (responsive matrix pass 2026-09-29, 320x568 and 360x640): on a short phone the panel does not fit its
// copy, so the column scrolls INSIDE the card instead of pushing Enter off-screen — and a line sliced in half at the
// card edge with no cue that there is more reads as a clipping bug. The fade is the cue.
const FADE_PX = 28;
const MASK = `linear-gradient(to bottom, #000 calc(100% - ${FADE_PX}px), transparent 100%)`;
const FADE_STYLE = { WebkitMaskImage: MASK, maskImage: MASK };
const NEAR_BOTTOM_PX = 4;

/**
 * @returns {[React.RefObject<HTMLElement>, object|undefined]} the ref for the scrolling element, and its mask style
 *   (undefined when everything fits or the guest is already at the end).
 */
export default function useScrollColumn() {
  const ref = useRef(null);
  const [fade, setFade] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const atEnd = () => el.scrollTop + el.clientHeight >= el.scrollHeight - NEAR_BOTTOM_PX;
    const update = () => setFade(el.scrollHeight > el.clientHeight + 1 && !atEnd());
    update();
    el.addEventListener('scroll', update, { passive: true });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    if (observer) observer.observe(el);
    return () => {
      el.removeEventListener('scroll', update);
      if (observer) observer.disconnect();
    };
  }, []);

  return [ref, fade ? FADE_STYLE : undefined];
}

export { FADE_PX, MASK };
